module.exports = __webpack_public_path__ + "img/BE0727958472.78f34a27.png";